"use strict";

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/opt/build/repo/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.refreshToken = exports.getAuthUser = exports.resetPassword = exports.forgetPassword = exports.signIn = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _toolkit = require("@reduxjs/toolkit");

var _graphql = _interopRequireDefault(require("../api/graphql"));

var _auth = require("../../utils/auth");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var signIn = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(args, source) {
    var _response$data, query, response, _response$data$login, authToken, _refreshToken, _response$data$login$, jwtAuthExpiration, capabilities, formattedCapabilities;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            query = "\n    mutation  {\n      login(\n        input: {\n          username: \"".concat(args.email, "\"\n          password: \"").concat(args.password, "\"\n          clientMutationId: \"login\"\n        }\n      ) {\n        authToken\n        refreshToken\n        user {\n          jwtAuthExpiration\n          capabilities\n        }\n      }\n    }\n  ");
            _context.next = 3;
            return (0, _graphql.default)(query, source);

          case 3:
            response = _context.sent;

            if (!(response !== null && response !== void 0 && (_response$data = response.data) !== null && _response$data !== void 0 && _response$data.login)) {
              _context.next = 9;
              break;
            }

            _response$data$login = response.data.login, authToken = _response$data$login.authToken, _refreshToken = _response$data$login.refreshToken, _response$data$login$ = _response$data$login.user, jwtAuthExpiration = _response$data$login$.jwtAuthExpiration, capabilities = _response$data$login$.capabilities;
            formattedCapabilities = {};
            capabilities.map(function (s) {
              formattedCapabilities[s] = true;
            });
            return _context.abrupt("return", {
              authToken: authToken,
              refreshToken: _refreshToken,
              jwtAuthExpiration: jwtAuthExpiration,
              capabilities: formattedCapabilities
            });

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function signIn(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

exports.signIn = signIn;

var forgetPassword = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(args, source) {
    var query, response;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            query = "\n    mutation {\n      sendPasswordResetEmail(\n        input: {\n          username: \"".concat(args.email, "\"\n          clientMutationId: \"forgotPassword\"\n        }\n      ) {\n        user {\n          email\n        }\n      }\n    }\n  ");
            _context2.next = 3;
            return (0, _graphql.default)(query, source);

          case 3:
            response = _context2.sent;
            return _context2.abrupt("return", response === null || response === void 0 ? void 0 : response.data);

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function forgetPassword(_x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();

exports.forgetPassword = forgetPassword;

var resetPassword = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(args, source) {
    var query, response;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            query = "\n    mutation {\n      resetUserPassword(\n        input: {\n          key: \"".concat(args.key, "\"\n          login: \"").concat(args.login, "\"\n          password: \"").concat(args.password, "\"\n          clientMutationId: \"changePassword\"\n        }\n      ) {\n        user {\n          email\n        }\n      }\n    }\n  ");
            _context3.next = 3;
            return (0, _graphql.default)(query, source);

          case 3:
            response = _context3.sent;
            return _context3.abrupt("return", response === null || response === void 0 ? void 0 : response.data);

          case 5:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function resetPassword(_x5, _x6) {
    return _ref3.apply(this, arguments);
  };
}();

exports.resetPassword = resetPassword;
var getAuthUser = (0, _toolkit.createAsyncThunk)('auth/getUser', /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(args, thunkAPI) {
    var _response$data2, _thunkAPI$getState, source, query, response, _response$data$viewer, id, email, capabilities, roles, jwtAuthExpiration, storageUser, formattedCapabilities;

    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _thunkAPI$getState = thunkAPI.getState(), source = _thunkAPI$getState.cms.config.source;
            query = "\n    query {\n      viewer {\n        id\n        email\n        capabilities\n        jwtAuthExpiration\n        roles {\n          nodes {\n            name\n          }\n        }\n      }\n    }\n  ";
            _context4.next = 4;
            return (0, _graphql.default)(query, source);

          case 4:
            response = _context4.sent;

            if (response !== null && response !== void 0 && (_response$data2 = response.data) !== null && _response$data2 !== void 0 && _response$data2.viewer) {
              _context4.next = 8;
              break;
            }

            (0, _auth.logout)({});
            return _context4.abrupt("return", null);

          case 8:
            _response$data$viewer = response.data.viewer, id = _response$data$viewer.id, email = _response$data$viewer.email, capabilities = _response$data$viewer.capabilities, roles = _response$data$viewer.roles, jwtAuthExpiration = _response$data$viewer.jwtAuthExpiration;
            storageUser = (0, _auth.getUser)();
            (0, _auth.setUser)(_objectSpread(_objectSpread({}, storageUser), {}, {
              jwtAuthExpiration: jwtAuthExpiration
            }));
            formattedCapabilities = {};
            capabilities.map(function (s) {
              formattedCapabilities[s] = true;
            });
            return _context4.abrupt("return", {
              id: id,
              email: email,
              capabilities: formattedCapabilities,
              roles: (roles === null || roles === void 0 ? void 0 : roles.nodes.map(function (o) {
                return o.name;
              })) || [],
              jwtAuthExpiration: jwtAuthExpiration
            });

          case 14:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function (_x7, _x8) {
    return _ref4.apply(this, arguments);
  };
}());
exports.getAuthUser = getAuthUser;
var refreshToken = (0, _toolkit.createAsyncThunk)('auth/refreshToken', /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(args, thunkAPI) {
    var _response$data3, _thunkAPI$getState2, source, storageUser, query, response, authToken;

    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _thunkAPI$getState2 = thunkAPI.getState(), source = _thunkAPI$getState2.cms.config.source;
            storageUser = (0, _auth.getUser)();
            query = "\n    mutation {\n      refreshJwtAuthToken(\n        input: {\n          jwtRefreshToken: \"".concat(storageUser.refreshToken, "\"\n          clientMutationId: \"refreshToken\"\n        }\n      ) {\n        authToken\n      }\n    }\n  ");
            _context5.next = 5;
            return (0, _graphql.default)(query, source);

          case 5:
            response = _context5.sent;

            if (response !== null && response !== void 0 && (_response$data3 = response.data) !== null && _response$data3 !== void 0 && _response$data3.refreshJwtAuthToken) {
              authToken = response.data.refreshJwtAuthToken.authToken; // Overwrite auth token

              (0, _auth.setUser)(_objectSpread(_objectSpread({}, storageUser), {}, {
                authToken: authToken
              }));
            } else {
              (0, _auth.logout)({});
            }

          case 7:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function (_x9, _x10) {
    return _ref5.apply(this, arguments);
  };
}());
exports.refreshToken = refreshToken;